import { defineComponent } from 'vue';
import { mapState, mapGetters, useStore } from 'vuex';
export default defineComponent({
  name: 'HuddlePop',
  setup() {
    return {
      store: useStore()
    };
  },
  computed: {
    ...mapState(['isShowVipPop']),
    ...mapGetters(['isYSvip', 'showVip'])
  },
  watch: {
    isYSvip(val) {
      val && this.quitHuddlePop();
    }
  },
  methods: {
    quitHuddlePop() {
      this.store.commit('update', {
        isShowVipPop: false
      });
    },
    goVip() {
      //跳转开通会员界面
      this.$stat({
        action: 'vip_accelerate_btn_click'
      });
      this.store.dispatch('goVip', {
        position: 'groupdl'
      });
    }
  }
});